/// <reference path="modal.module.ts" />

module Meevo.Components.Modal {

    import ShortCutGroup = Meevo.Components.ShortCuts.ShortCutGroup;

    class ModalController {

        okButtonShortCut: string;
        cancelButtonShortCut: string;
        public locationId: number;
        public displayPopupNotesAcrossLocations: boolean;
        public showClientNotesAcrossLocation: boolean;
        private scope: any;
        private modal: angular.material.IDialogService;
        private message: string;
        private modalType: ModalTypeEnum;
        private modalClass: string;
        private showOkButton: boolean;
        private showCancelButton: boolean;
        private okButtonContentKey: string;
        private cancelButtonContentKey: string;
        private okButtonSecurityKey: string;
        private cancelButtonSecurityKey: string;
        private headerContentKey: string;
        private processNegativeConfirm: boolean;
        private additionalButtons: IModalAdditionalButton[];
        private shortCutGroup: IShortCutGroup;
        private locals: any;
        private userOptions: ILocalOptions;
        errorMessage: string = "";

        static $inject = [
            '$scope',
            '$mdDialog',
            '$q',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.common.DataService',
            'meevo.components.common.IdentityService',
            '$translate'
        ];

        constructor(
            $scope: angular.IScope,
            $mdDialog: angular.material.IDialogService,
            public $q: ng.IQService,
            private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected $translate: angular.translate.ITranslateService,
            message: string,
            modalType: ModalTypeEnum,
            processNegativeConfirm: boolean
        ) {
            this.scope = $scope;
            this.modal = $mdDialog;
            this.locationId = this.identityService.current().locationId;
            this.displayPopupNotesAcrossLocations = this.scope.$root['clientsSettings'].displayPopupNotesAcrossLocations;
            this.showClientNotesAcrossLocation = this.scope.$root['clientsSettings'].showClientNotesAcrossLocation;

            this.configureModal();

            if (!_.isUndefined(this.locals.userOptions)) {
                if (this.locals.userOptions.showCancelButton) {
                    this.showCancelButton = this.userOptions.showCancelButton;
                }

                if (this.locals.userOptions.showCancelButton && !_.isUndefined(this.locals.userOptions.cancelButtonContentKey)) {
                    this.cancelButtonContentKey = this.userOptions.cancelButtonContentKey;
                }

                if (!_.isUndefined(this.locals.userOptions.okButtonContentKey)) {
                    this.okButtonContentKey = this.locals.userOptions.okButtonContentKey;
                }

                if (!_.isUndefined(this.locals.userOptions.okButtonSecurityKey)) {
                    this.okButtonSecurityKey = this.locals.userOptions.okButtonSecurityKey;
                }

                if (!_.isUndefined(this.locals.userOptions.cancelButtonSecurityKey)) {
                    this.cancelButtonSecurityKey = this.locals.userOptions.cancelButtonSecurityKey;
                }

                if (!_.isUndefined(this.locals.userOptions.modalClass)) {
                    this.modalClass = this.locals.userOptions.modalClass;
                }

                if (!_.isUndefined(this.locals.userOptions.additionalButtons)) {
                    this.additionalButtons = this.locals.userOptions.additionalButtons;
                }
            }

            this.configureShortCuts();

            this.shortCutsService.activateGroup(this.shortCutGroup);
        }

        /**
        * Shared method used to configure any non-custom modal.
        */
        private configureModal(): void {
            switch (this.modalType) {
                case ModalTypeEnum.Alert: {
                    this.modalClass = 'modal-alert';
                    this.headerContentKey = this.headerContentKey || 'HEADER_ALERT';
                    this.okButtonContentKey = 'LABEL_OK';
                    this.cancelButtonContentKey = 'LABEL_CANCEL'; // Not displayed
                    this.showOkButton = true;
                    this.showCancelButton = false;
                    break;
                }

                case ModalTypeEnum.Confirm: {
                    this.modalClass = 'modal-confirm';
                    this.headerContentKey = 'HEADER_CONFIRM';
                    this.okButtonContentKey = 'LABEL_YES';
                    this.cancelButtonContentKey = 'LABEL_NO';
                    this.showOkButton = true;
                    this.showCancelButton = true;
                    break;
                }

                case ModalTypeEnum.Error: {
                    this.modalClass = 'modal-error';
                    this.headerContentKey = 'HEADER_ERROR';
                    this.okButtonContentKey = 'LABEL_OK';
                    this.cancelButtonContentKey = 'LABEL_CANCEL'; // Not displayed
                    this.showOkButton = true;
                    this.showCancelButton = false;
                    break;
                }

                case ModalTypeEnum.Warning: {
                    this.modalClass = 'modal-warning';
                    this.headerContentKey = 'HEADER_WARNING';
                    this.okButtonContentKey = 'LABEL_OK';
                    this.cancelButtonContentKey = 'LABEL_CANCEL'; // Not displayed
                    this.showOkButton = true;
                    this.showCancelButton = false;
                    break;
                }

                case ModalTypeEnum.OkCancel: {
                    this.modalClass = 'modal-confirm';
                    this.headerContentKey = 'HEADER_CONFIRM';
                    this.okButtonContentKey = 'LABEL_OK';
                    this.cancelButtonContentKey = 'LABEL_CANCEL';
                    this.showOkButton = true;
                    this.showCancelButton = true;
                    break;
                }

                case ModalTypeEnum.Info: {
                    this.modalClass = 'modal-info';
                    this.headerContentKey = this.headerContentKey || 'HEADER_INFO';
                    this.okButtonContentKey = 'LABEL_OK';
                    this.cancelButtonContentKey = 'LABEL_CANCEL'; // Not displayed
                    this.showOkButton = true;
                    this.showCancelButton = false;
                    break;
                }

                case ModalTypeEnum.Note:
                case ModalTypeEnum.NoteRegister: {
                    this.modalClass = 'modal-note';
                    this.headerContentKey = 'LABEL_NOTE';
                    this.okButtonContentKey = 'LABEL_OK';
                    this.cancelButtonContentKey = 'LABEL_CANCEL'; // Not displayed
                    this.showOkButton = true;
                    this.showCancelButton = false;
                    break;
                }

                case ModalTypeEnum.Message: {
                    this.modalClass = 'modal-note';
                    this.headerContentKey = null;
                    this.okButtonContentKey = 'LABEL_OK';
                    this.cancelButtonContentKey = 'LABEL_CANCEL'; // Not displayed
                    this.showOkButton = true;
                    this.showCancelButton = false;
                    break;
                }
            }
        }

        /**
        * Method used to handle hiding a modal with a positive response.
        */
        ok(): void {
            this.modal.hide(true);

            this.shortCutsService.deactivateGroup(this.shortCutGroup);
        }

        /**
        * Method used to handle hiding a modal with a negative response.
        */
        cancel(): void {
            if (this.processNegativeConfirm) {
                this.modal.hide(false);
            }
            else {
                this.modal.cancel(false);
            }
            this.shortCutsService.deactivateGroup(this.shortCutGroup);
        }

        saveClientNotes(notes: any[]): void {
            let clientNotes = _(notes).where({ isClientNote: true });
            let promises = this.updateClientNotes(clientNotes);
            if (promises.length > 0) {
                this.$q.all(promises).then((data: any) => {
                    if (!this.errorMessage) {
                        this.modal.hide(true);
                        this.shortCutsService.deactivateGroup(this.shortCutGroup);
                    } else {
                        //alert(this.errorMessage); //-> here we can enhance and display detailed message for failed Client / Notes
                        this.errorMessage = "";
                    }
                });
            } else {
                this.modal.hide(true);
                this.shortCutsService.deactivateGroup(this.shortCutGroup);
            }
        }

        updateClientNotes(notes: any[]) {
            var promises = [];
            _(notes).each((note: any) => {
                let clientNote = this.clientNoteNeedsToBeUpdated(note);
                if (clientNote) {
                    promises.push(this.updateClientNote(clientNote, note));
                }
            });
            return promises;
        }

        updateClientNote(clientNote: any, note: any) {
            return this.dataService.update('client', clientNote, <Guid>clientNote.clientGlobalId, 'notes')
                .then((data: any) => {
                    clientNote = data;
                })
                .catch((err: any) => {
                    this.errorMessage += note.displayName + ': ' + err.data.responseStatus.message + '\n';
                });
        }

        clientNoteNeedsToBeUpdated(note: any): Meevo.Plugins.Note.INote {
            let originalNote = note.originalNote;
           if  ((originalNote.isAppointmentBooked !== note.isAppointmentBooked || 
                originalNote.isCheckIn !== note.isCheckIn ||
                originalNote.isCheckOut !== note.isCheckOut) &&
                (!this.displayPopupNotesAcrossLocations || originalNote.locationId == this.locationId)
                ){
                const updateNote: Meevo.Plugins.Note.INote = {
                    id: note.id,
                    entityId: note.entityId,
                    clientGlobalId: note.clientGlobalId,
                    clientType: note.clientType,
                    displayName: note.displayName,
                    noteText: originalNote.note,
                    isAppointmentType: originalNote.isAppointmentType,
                    isRegisterType: originalNote.isRegisterType,
                    isAppointmentBooked: note.isAppointmentBooked,
                    isCheckIn: note.isCheckIn,
                    isCheckOut: note.isCheckOut,
                    locationId: note.locationId,
                    locationName: note.locationName,
                    isNewNote: false,
                    isGroupedNote: false,
                    entityVersion: note.entityVersion,
                    originalNote: null,
                };
                return updateNote;
            }
            return null;
        }

        hasAppointmentNotes(notes: any[]) {
            return _(notes).any(note => note.isAppointmentNote);
        }

        hasClientNotes(notes: any[]) {
            return _(notes).any(note => note.isClientNote);
        }

        hasMembershipNotes(notes: any[]) {
            return _(notes).any(note => note.isMembershipNote);
        }

        hasServiceNotes(notes: any[]) {
            return _(notes).any(note => note.isServiceNote);
        }

        private configureShortCutsForOk(modalOptions) {
            this.okButtonShortCut = 'MODAL_OK_BUTTON';

            if (!_.isUndefined(this.locals.userOptions)) {

                if (this.locals.userOptions.okButtonHotKey) {
                    this.okButtonShortCut = this.locals.userOptions.okButtonHotKey;
                }

                if (!_.isUndefined(this.locals.userOptions.okButtonContentKey)) {
                    this.okButtonContentKey = this.locals.userOptions.okButtonContentKey;
                }
            }

            this.shortCutGroup = new ShortCutGroup([
                {
                    shortCutName: this.okButtonShortCut ,
                    callback: () => {
                        this.ok();
                    }
                },
                {
                    shortCutName: 'MODAL_DISMISS',
                    callback: (event: Event, hotkey: ng.hotkeys.Hotkey) => {
                        event.preventDefault();

                        this.ok();
                    }
                }
            ], modalOptions);
        }

        private configureShortCutsForNotes(modalOptions) {
            this.okButtonShortCut = 'MODAL_OK_BUTTON';
            if (!_.isUndefined(this.locals.userOptions)) {
                if (this.locals.userOptions.okButtonHotKey) {
                    this.okButtonShortCut = this.locals.userOptions.okButtonHotKey;
                }
                if (!_.isUndefined(this.locals.userOptions.okButtonContentKey)) {
                    this.okButtonContentKey = this.locals.userOptions.okButtonContentKey;
                }
            }
            this.shortCutGroup = new ShortCutGroup([
                {
                    shortCutName: this.okButtonShortCut,
                    callback: () => {
                        this.saveClientNotes(this.locals.notes);
                    }
                },
                {
                    shortCutName: 'MODAL_DISMISS',
                    callback: (event: Event, hotkey: ng.hotkeys.Hotkey) => {
                        event.preventDefault();
                        this.saveClientNotes(this.locals.notes);
                    }
                }
            ], modalOptions);
        }

        private configureShortCutsForYesNo(modalOptions) {
            this.okButtonShortCut = 'MODAL_YES_BUTTON';
            this.cancelButtonShortCut = 'MODAL_NO_BUTTON';
            this.shortCutGroup = new ShortCutGroup([
                {
                    shortCutName: 'MODAL_YES_BUTTON',
                    callback: () => {
                        this.ok();
                    }
                },
                {
                    shortCutName: 'MODAL_NO_BUTTON',
                    callback: () => {
                        this.cancel();
                    }
                }
            ], modalOptions);
        }

        private configureShortCutsForOkCancel(modalOptions) {
            this.okButtonShortCut = 'MODAL_OK_BUTTON';
            this.cancelButtonShortCut = 'MODAL_CANCEL_BUTTON';

            if (!_.isUndefined(this.locals.userOptions)) {
                if (this.locals.userOptions.okButtonHotKey) {
                    this.okButtonShortCut = this.locals.userOptions.okButtonHotKey;
                }
                if (this.locals.userOptions.cancelButtonHotKey) {
                    this.cancelButtonShortCut = this.locals.userOptions.cancelButtonHotKey;
                }

                if (this.locals.userOptions.showCancelButton && !_.isUndefined(this.locals.userOptions.cancelButtonContentKey)) {
                    this.cancelButtonContentKey = this.locals.userOptions.cancelButtonContentKey;
                }

                if (!_.isUndefined(this.locals.userOptions.okButtonContentKey)) {
                    this.okButtonContentKey = this.locals.userOptions.okButtonContentKey;
                }
            }
            this.shortCutGroup = new ShortCutGroup([
                {
                    shortCutName: this.okButtonShortCut,
                    callback: () => {
                        this.ok();
                    }
                },
                {
                    shortCutName: this.cancelButtonShortCut,
                    callback: () => {
                        this.cancel();
                    }
                }
            ], modalOptions);
        }

        private configureShortCuts() {

            const modalOptions = {
                groupLevel: Components.ShortCuts.GroupLevels.Modal,
                deactivateGlobal: true,
            };

            switch (this.modalType) {
                case ModalTypeEnum.Alert:
                case ModalTypeEnum.Info:
                case ModalTypeEnum.Note:
                case ModalTypeEnum.Message:
                    this.configureShortCutsForOk(modalOptions);
                    break;

                case ModalTypeEnum.NoteRegister:
                    this.configureShortCutsForNotes(modalOptions);
                    break;

                case ModalTypeEnum.Confirm:
                    this.configureShortCutsForYesNo(modalOptions);
                    break;

                case ModalTypeEnum.OkCancel:
                case ModalTypeEnum.Warning:
                case ModalTypeEnum.Error:
                    this.configureShortCutsForOkCancel(modalOptions);
                    break;
            }
        }
    }

    angular.module('meevo.components.modal')
        .controller('meevo.components.modal.ModalController', ModalController)
        .filter('clientNoteByType', [
            () => (noteItems, noteType) => {
                return _(noteItems).filter(note =>
                    (noteType === 'clientNote' && note.isClientNote) ||
                    (noteType === 'appointmentNote' && note.isAppointmentNote) ||
                    (noteType === 'serviceNote' && note.isServiceNote) ||
                    (noteType === 'membershipNote' && note.isMembershipNote)
                );
            }
        ]);
}
